export default __webpack_public_path__ + "images/ac0299a26339dc029a2671ba02aaa40b.svg";